import { useState, useEffect } from "react"

/**
 * Reactive media query hook.
 * @param query CSS media query string (e.g. "(max-width: 768px)")
 * @returns boolean — true if the query currently matches
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === "undefined") return
    const mql = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
    // Initial sync in case it changed between render and effect
    setMatches(mql.matches)
    mql.addEventListener("change", handler)
    return () => mql.removeEventListener("change", handler)
  }, [query])

  return matches
}

/** Convenience: true when viewport is mobile-sized (<768px) */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 768px)")
}
